import script from "./ProjectCase.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectCase.vue?vue&type=script&setup=true&lang=js"

import "./ProjectCase.vue?vue&type=style&index=0&id=75cf57fc&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/spepi.cn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75cf57fc"]])

export default __exports__